import { ZipCodeBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const Zip: React.FC = () => {
    const zip = usePaymentStore((s) => s.zip);
    const set_zip = usePaymentStore((s) => s.set_zip);

    return (
        <ZipCodeBox
            id='card-billing-state'
            value={zip}
            onChange={(value) => set_zip(value)}
            label='Zip Code'
            required={true}
        />
    );
};
